<script lang="ts">
	import { Auth } from "@utils/Auth.svelte.js";
	import { getTranslate } from "@utils/getTranslate.js";
	import { isMenuActive } from "@utils/isMenuActive.js";
	import type { ClassValue, MouseEventHandler } from "svelte/elements";
	import logoutIcon from "@core/assets/icons/logout.svg?raw";
	import { getGlobalTemplateProps } from "../contexts/getGlobalTemplateProps.js";
	import translations from "./AuthenticationMenu.translations.json" with { type: "json" };
	import { getAuthMenuItems } from "./authMenuItems.js";
	import FFCMemberBadge from "./common/FFCMemberBadge.svelte";
	import Formatted from "./common/Formatted.svelte";
	import Icon from "./common/Icon.svelte";

	const { tenant, pagePath } = getGlobalTemplateProps();
	const currentPath = pagePath[tenant.locale];
	const { class: customClass, onsignout }: { class?: ClassValue; onsignout: MouseEventHandler<HTMLButtonElement> } =
		$props();

	const translate = getTranslate(translations);
</script>

<div class={[customClass, "bg-white p-4 rounded-3xl flex flex-col gap-4"]}>
	{#if Auth.loggedCustomer}
		<div class="flex flex-col gap-4 items-start" data-clarity-mask="true">
			<span class="text-sm/none font-medium inline-flex flex-wrap gap-1">
				{#if Auth.loggedCustomer.fullName}
					<Formatted text={Auth.loggedCustomer.fullName} />
					<span>–</span>
				{/if}
				<Formatted text={Auth.loggedCustomer.email} />
			</span>
			{#if Auth.isFfcMember}
				<FFCMemberBadge class="inline-flex" />
			{/if}
		</div>
		<hr class="border-0 h-px bg-fcrlightgray" />
	{/if}
	{#each getAuthMenuItems(tenant, Auth.customerType) as item (item)}
		{#if currentPath !== undefined && isMenuActive(item, currentPath)}
			<span class="flex items-center gap-2 text-fcrbrown">
				<Icon icon={item.icon} class="size-6" />
				<span class="font-medium text-base">
					<Formatted text={item.name} />
				</span>
			</span>
		{:else}
			<a href={item.href} class="flex items-center gap-2 text-fcrdarkgray hover:text-fcrbrown transition-colors">
				<Icon icon={item.icon} class="size-6 text-fcrgray" />
				<span class="font-medium text-base">
					<Formatted text={item.name} />
				</span>
			</a>
		{/if}
	{/each}
	<hr class="border-0 h-px bg-fcrlightgray" />
	<button
		type="button"
		onclick={onsignout}
		class="flex items-center gap-2 text-fcrdarkgray hover:text-fcrbrown transition-colors"
	>
		<Icon icon={logoutIcon} class="size-6 text-fcrgray" />
		<span class="font-medium text-base">
			<Formatted text={translate("signout")} />
		</span>
	</button>
</div>
